import emailjs from "emailjs-com";
import toast from "react-hot-toast";
import contact from "../../assets/images/contact.png";
import "./Contact.css";

const Contact = () => {
  const sendEmail = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        process.env.REACT_APP_EMAILJS_SERVICEID,
        process.env.REACT_APP_EMAILJS_TEMPLATEID,
        e.target,
        process.env.REACT_APP_EMAILJS_USERID
      )
      .then((res) => {
        toast.success("Message Sent Successfully");
        e.target.name.value = "";
        e.target.email.value = "";
        e.target.message.value = "";
      })
      .catch((err) => toast.error(err));
  };

  return (
    <div
      data-aos="fade-up"
      data-aos-duration="3000"
      className="container my-5"
      id="contact"
    >
      <h1 className="text-center fw-bold text-uppercase">Contact</h1>
      <div className="row d-flex align-items-center">
        <div className="col-lg-6">
          <img src={contact} className="img-fluid w-100" alt="..." />
        </div>
        <div className="col-lg-6">
          <form onSubmit={sendEmail}>
            <div className="mb-3">
              <label htmlFor="nameInput" className="form-label">
                Name
              </label>
              <input
                type="text"
                name="name"
                className="form-control bg-transparent p-3"
                id="nameInput"
                aria-describedby="nameHelp"
                placeholder="Enter your Name here"
                required
              />
            </div>
            <div className="mb-3">
              <label htmlFor="inputEmail1" className="form-label">
                Email address
              </label>
              <input
                type="email"
                name="email"
                className="form-control bg-transparent p-3"
                id="inputEmail1"
                aria-describedby="emailHelp"
                placeholder="Enter your email address"
                required
              />
            </div>
            <div className="mb-3">
              <label htmlFor="inputMessage" className="form-label">
                Message
              </label>
              <textarea
                className="form-control bg-transparent p-3"
                name="message"
                id="inputMessage"
                rows="10"
                placeholder="Enter your message here"
                required
              ></textarea>
            </div>
            <div className="d-grid gap-2">
              <button type="submit" className="btn btn_shadow">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;
